import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAnalytics } from "../../hooks/useAnalytics";

const ShortletDetails = () => {
  useAnalytics();
  
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      window.location.href = `${process.env.REACT_APP_API}/adDetailsScreen/${id}`;
    }
  }, [id]);

  return <p>Redirecting to NimbleCasa app...</p>;
};

export default ShortletDetails;
